import { render, staticRenderFns } from "./EventVideo.vue?vue&type=template&id=78ff8b54"
import script from "./EventVideo.vue?vue&type=script&lang=js"
export * from "./EventVideo.vue?vue&type=script&lang=js"
import style0 from "./EventVideo.vue?vue&type=style&index=0&id=78ff8b54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports